import React from "react";
import { Link, useParams } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { services } from "../mock";
import {
  Building2, FileSignature, Landmark, HeartCrack, ShieldAlert, Briefcase,
  Users, IndianRupee, ShoppingBag, KeyRound, HardHat, Scale, Laptop, Copyright, FileText, Home, ArrowRight, CheckCircle2,
  Banknote, Car, Receipt
} from "lucide-react";

const iconMap = {
  Building2, FileSignature, Landmark, HeartCrack, ShieldAlert, Briefcase,
  Users, IndianRupee, ShoppingBag, KeyRound, HardHat, Scale, Laptop, Copyright, FileText, Home,
  Banknote, Car, Receipt
};

export default function ServiceDetail() {
  const { slug } = useParams();
  const service = services.find((s) => s.slug === slug) || services[0];
  const Icon = iconMap[service.icon] || Scale;
  const related = services.filter((s) => s.slug !== service.slug).slice(0, 6);

  const bullets = [
    "Personalised strategy tailored to your matter",
    "Transparent fee structure and timelines",
    "Regular updates via WhatsApp and email",
    "Representation before all appropriate forums",
  ];

  return (
    <>
      <Header />

      <section
        className="h-[38vh] min-h-[260px] w-full bg-cover bg-center relative flex items-end"
        style={{
          backgroundImage:
            "linear-gradient(rgba(10,20,40,0.88), rgba(10,20,40,0.88)), url('https://images.pexels.com/photos/5669619/pexels-photo-5669619.jpeg?auto=compress&cs=tinysrgb&w=1920')",
        }}
      >
        <div className="container-x pb-12 text-white">
          <span className="text-[#c9a961] uppercase tracking-[0.35em] text-xs font-semibold">Practice Area</span>
          <h1 className="font-serif-display text-3xl md:text-5xl mt-3">{service.title}</h1>
          <div className="text-sm text-neutral-300 mt-3">
            <Link to="/" className="hover:text-[#c9a961]">Home</Link> <span className="mx-2">/</span>
            <Link to="/#services" className="hover:text-[#c9a961]">Practice Areas</Link> <span className="mx-2">/</span>
            <span className="text-white">{service.title}</span>
          </div>
        </div>
      </section>

      <section className="py-16">
        <div className="container-x grid grid-cols-1 lg:grid-cols-3 gap-10">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-16 h-16 rounded-sm bg-[#0e1b34] text-[#c9a961] flex items-center justify-center">
                <Icon size={28} />
              </div>
              <h2 className="font-serif-display text-3xl text-[#0e1b34]">{service.title}</h2>
            </div>
            <p className="text-neutral-700 leading-relaxed text-lg mb-6">{service.description}</p>
            <p className="text-neutral-700 leading-relaxed mb-8">
              Our team leverages deep subject-matter expertise, procedural precision and technology to give
              our clients an edge. Every case receives a bespoke strategy driven by our founder Adv. Pravin
              K. Gupta and executed by a seasoned team of Advocates.
            </p>

            <div className="bg-[#f7f2e8]/60 border-l-4 border-[#c9a961] p-6 rounded-sm mb-8">
              <h3 className="font-serif-display text-xl text-[#0e1b34] mb-4">What you can expect</h3>
              <ul className="space-y-3">
                {bullets.map((b, i) => (
                  <li key={i} className="flex items-start gap-3 text-neutral-700">
                    <CheckCircle2 className="text-[#c9a961] mt-0.5 flex-shrink-0" size={18} />
                    <span>{b}</span>
                  </li>
                ))}
              </ul>
            </div>

            <Link to="/#appointment" className="btn-gold">
              Book a Consultation <ArrowRight size={14} />
            </Link>
          </div>

          <aside className="space-y-6">
            <div className="bg-[#0e1b34] text-white p-7 rounded-sm">
              <h4 className="font-serif-display text-xl mb-2">Need Legal Advice?</h4>
              <p className="text-sm text-neutral-300 mb-5">Speak to a specialist in {service.title.toLowerCase()} today.</p>
              <Link to="/contact" className="btn-outline-gold">Contact Us</Link>
            </div>
            <div className="bg-white border border-neutral-200 rounded-sm p-6">
              <h4 className="font-serif-display text-lg text-[#0e1b34] mb-4 gold-underline">Other Practice Areas</h4>
              <ul className="space-y-3 text-sm">
                {related.map((r) => (
                  <li key={r.slug}>
                    <Link to={`/services/${r.slug}`} className="flex items-center justify-between text-neutral-700 hover:text-[#b28e42] group">
                      <span>{r.title.charAt(0) + r.title.slice(1).toLowerCase()}</span>
                      <ArrowRight size={14} className="opacity-0 group-hover:opacity-100 transition-opacity" />
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </aside>
        </div>
      </section>

      <Footer />
    </>
  );
}
